import { ArrowUpRight } from "lucide-react";

const VIDEO_ID = "d5EoQ6RlNvU";

export default function Voices() {
  return (
    <section id="voices" className="relative bg-mist py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <div className="lg:col-span-5">
          <div className="eyebrow text-gold">See CDaught in Action</div>
          <h2 className="font-serif text-4xl sm:text-5xl text-navy mt-3 font-bold tracking-tight leading-[1.05]">
            Watch the
            <span className="block italic font-medium">room shift.</span>
          </h2>
          <p className="mt-5 text-[15px] text-navy/65 max-w-md leading-relaxed">
            Highlights from recent assemblies, professional development sessions, and conference
            keynotes across districts and organizations.
          </p>
          <a
            href={`https://youtu.be/${VIDEO_ID}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="voices-youtube-link"
            className="mt-7 inline-flex items-center gap-2 text-[14px] font-semibold text-navy hover:text-gold transition-colors"
          >
            Watch on YouTube <ArrowUpRight size={16} />
          </a>
        </div>

        <div
          data-testid="video-embed"
          className="lg:col-span-7 relative aspect-video overflow-hidden bg-navy shadow-2xl"
        >
          <iframe
            src={`https://www.youtube.com/embed/${VIDEO_ID}?rel=0&modestbranding=1`}
            title="See CDaught in Action"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className="absolute inset-0 w-full h-full"
            frameBorder="0"
          />
        </div>
      </div>
    </section>
  );
}
